//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import React from 'react';
import { useTranslation } from 'react-i18next';
import Resources from '../Home/resources';
import { documentationStyles } from '../../styles/Documentation';

interface LeftSectionProps {
  zoom: number;
  sidebarExpanded?: boolean;
}

const LeftSection: React.FC<LeftSectionProps> = ({ zoom, sidebarExpanded }) => {
  const { t } = useTranslation();
  const scaledPadding = Math.round(
    documentationStyles.leftSection.basePadding / zoom,
  );

  return (
    <div
      id="id-left-section"
      data-testid="left-section"
      style={{
        ...documentationStyles.leftSection.container,
        padding: `${scaledPadding}px`,
        overflowY: sidebarExpanded ? 'auto' : undefined,
        maxHeight: sidebarExpanded ? '100%' : undefined,
      }}
    >
      <div
        id="id-docs-left-inner"
        data-testid="docs-left-inner"
        style={documentationStyles.leftSection.inner}
      >
        <div
          id="id-docs-left-support-wrapper"
          data-testid="docs-left-support-wrapper"
          style={{ marginTop: '20px' }}
        >
          <span
            id="id-docs-left-support-info"
            data-testid="docs-left-support-info"
            style={{
              ...documentationStyles.leftSection.supportInfo,
            }}
          >
            {t('documentation-support-info')}
          </span>
        </div>
        <div
          id="id-docs-left-paragraph"
          data-testid="docs-left-paragraph"
          style={{
            ...documentationStyles.leftSection.paragraph,
            textAlign: 'left',
          }}
        >
          {t('documentation-opening-paragraph')}
        </div>
        <Resources />
      </div>
    </div>
  );
};

export default LeftSection;
